module.exports = __webpack_public_path__ + "img/mockup.dcd33168.png";